import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _hoisted_1 = { id: "brand_painter_div" }
const _hoisted_2 = { id: "brand_painter_title" }
const _hoisted_3 = { id: "brand_painter_list_box" }
const _hoisted_4 = ["item"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { id: "painter_box" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  id: "box_icon",
  src: _imports_0
}, null, -1)
const _hoisted_8 = {
  key: 0,
  id: "painter_box_for_news_des"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxWithBtn = _resolveComponent("BoxWithBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(this.$props.item.title), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$props.item.details, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          id: "painter_box_details",
          key: index,
          item: item
        }, [
          _createElementVNode("img", {
            id: "painter_box_for_news_img",
            src: item.conver
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (item.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.title), 1))
              : _createCommentVNode("", true),
            (item.link)
              ? (_openBlock(), _createBlock(_component_BoxWithBtn, {
                  key: 1,
                  text: "了解详情",
                  onClick: ($event: any) => (_ctx.onDetail(item.link))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}